import { computed, observable, action, makeObservable } from 'mobx'

export class ConfirmViewModel {
  @observable
  showing = false

  @observable
  bulkConfirm = false

  _resolve: ((value: boolean) => unknown) | null = null

  constructor() {
    makeObservable(this)
  }

  /**
   * Called once the user clicks the confirm button.
   */
  @action.bound
  confirm() {
    this.showing = false
    if (this._resolve) {
      this._resolve(true)
    }
  }

  /**
   * Called once the user clicks the decline button.
   */
  @action.bound
  async decline() {
    this.showing = false
    if (this._resolve) {
      this._resolve(false)
    }
  }

  @action.bound
  show(onConfirm?: () => unknown) {
    this.showing = true
    return new Promise<boolean>((resolve) => {
      this._resolve = resolve
    }).then(async (confirmed) => {
      if (onConfirm && confirmed) {
        await onConfirm()
      }
      return confirmed
    })
  }

  @action.bound
  showForBulk(size: number, onConfirm?: () => unknown) {
    this.bulkConfirm = size > 1
    this.showing = true
    return new Promise<boolean>((resolve) => {
      this._resolve = resolve
    }).then(async (confirmed) => {
      if (onConfirm && confirmed) {
        await onConfirm()
      }
      this.bulkConfirm = false
      return confirmed
    })
  }

  @computed
  get isOpened() {
    return this.showing
  }
}
